import React, { useState, useEffect } from 'react';
import AutocompleteInput from './AutocompleteInput';
import API_CONFIG from './config/api';

const CadastrarVeiculoModalClean = ({ veiculo, onClose, onSave, userLogado, onDelete, onVerJornada, onToggleSeguir, seguindo }) => {
  const [currentStep, setCurrentStep] = useState(1);
  const [seguindoLocal, setSeguindoLocal] = useState(seguindo);
  const [formData, setFormData] = useState({
    marca: '',
    modelo: '',
    versao: '',
    ano_fabricacao: '',
    ano_modelo: '',
    cor: '',
    placa: '',
    km: '',
    combustivel: '',
    tipo: 'Venda normal',
    localizacao: '',
    fornecedor_id: null,
    status: 'Disponível',
    preco_venda: ''
  });

  const [marcasFipe, setMarcasFipe] = useState([]);
  const [modelosFipe, setModelosFipe] = useState([]);
  const [marcaSelecionadaId, setMarcaSelecionadaId] = useState(null);
  const [modeloSelecionadoId, setModeloSelecionadoId] = useState(null);
  const [loadingMarcas, setLoadingMarcas] = useState(false);
  const [loadingModelos, setLoadingModelos] = useState(false);
  const [fornecedores, setFornecedores] = useState([]);
  const [buscaLocalizacao, setBuscaLocalizacao] = useState('');
  const [mostrarSugestoesLoc, setMostrarSugestoesLoc] = useState(false);

  const tiposDescricao = {
    'Venda normal': 'Venda com garantia e comissão normal',
    'Repasse 1': 'Veículos vendidos sem garantia, com margem abaixo do praticado na loja. Valor: R$ 500,00 (não conta para meta).',
    'Repasse 2': 'Motos. Valor: R$ 250,00 (não conta para meta).',
    'Repasse 3': 'Veículos vendidos sem garantia, com margem normal praticada pela loja. Comissão normal e conta para meta.'
  };

  const coresDisponiveis = [
    'Preto',
    'Branco',
    'Prata',
    'Cinza',
    'Vermelho',
    'Azul',
    'Verde',
    'Amarelo',
    'Laranja',
    'Marrom',
    'Bege',
    'Dourado',
    'Bronze',
    'Vinho',
    'Bordô',
    'Rosa',
    'Roxo',
    'Grafite'
  ];

  useEffect(() => {
    if (veiculo) {
      setFormData({
        marca: veiculo.marca || '',
        modelo: veiculo.modelo || '',
        versao: veiculo.versao || '',
        ano_fabricacao: veiculo.ano_fabricacao || '',
        ano_modelo: veiculo.ano_modelo || '',
        cor: veiculo.cor || '',
        placa: veiculo.placa || '',
        km: veiculo.km || '',
        combustivel: veiculo.combustivel || '',
        tipo: veiculo.tipo || 'Venda normal',
        localizacao: veiculo.localizacao || '',
        fornecedor_id: veiculo.fornecedor_id || null,
        status: veiculo.status || 'Disponível',
        preco_venda: veiculo.preco_venda || ''
      });
      setBuscaLocalizacao(veiculo.localizacao || '');
    }
  }, [veiculo]);

  useEffect(() => {
    setSeguindoLocal(seguindo);
  }, [seguindo]);

  useEffect(() => {
    carregarFornecedores();
    
    // Fechar sugestões ao clicar fora
    const handleClickOutside = (e) => {
      if (!e.target.closest('.autocomplete-localizacao-container')) {
        setMostrarSugestoesLoc(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const carregarFornecedores = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await fetch(`${API_CONFIG.API_URL}/fornecedores`, {
        headers: { 'x-auth-token': token }
      });

      if (response.ok) {
        const data = await response.json();
        if (data.success) {
          const fornecedoresAtivos = data.data.filter(f => f.ativo);
          setFornecedores(fornecedoresAtivos);
        }
      }
    } catch (error) {
    }
  };

  // Localizações padrão
  const localizacoesPadrao = ['Loja 1', 'Loja 3', 'Feirão'];

  // Filtrar sugestões de localização
  const filtrarSugestoesLocalizacao = () => {
    const buscaLower = buscaLocalizacao.toLowerCase();
    
    if (buscaLocalizacao.trim() === '') {
      return {
        localizacoes: localizacoesPadrao,
        fornecedores: fornecedores
      };
    }
    
    const localizacoesFiltradas = localizacoesPadrao.filter(loc =>
      loc.toLowerCase().includes(buscaLower)
    );
    
    const fornecedoresFiltrados = fornecedores.filter(f =>
      f.nome.toLowerCase().includes(buscaLower)
    );
    
    return {
      localizacoes: localizacoesFiltradas,
      fornecedores: fornecedoresFiltrados
    };
  };

  const handleBuscaLocalizacaoChange = (e) => {
    const valor = e.target.value;
    setBuscaLocalizacao(valor);
    // Ao digitar manualmente, limpamos o ID do fornecedor para evitar inconsistências
    setFormData(prev => ({ ...prev, localizacao: valor, fornecedor_id: null }));
    setMostrarSugestoesLoc(true);
  };

  const selecionarLocalizacao = (loc, fornecedorId = null) => {
    setFormData(prev => ({ 
      ...prev, 
      localizacao: loc,
      fornecedor_id: fornecedorId
    }));
    setBuscaLocalizacao(loc);
    setMostrarSugestoesLoc(false);
  };

  const sugestoesLocalizacao = filtrarSugestoesLocalizacao();

  // Buscar marcas FIPE
  useEffect(() => {
    const fetchMarcas = async () => {
      setLoadingMarcas(true);
      try {
        const response = await fetch('https://parallelum.com.br/fipe/api/v1/carros/marcas');
        if (response.ok) {
          const data = await response.json();
          const marcasNomes = data.map(m => ({ id: m.codigo, nome: m.nome }));
          setMarcasFipe(marcasNomes);
        }
      } catch (error) {
      } finally {
        setLoadingMarcas(false);
      }
    };

    fetchMarcas();
  }, []);

  // Buscar modelos FIPE quando marca E ano modelo forem selecionados
  useEffect(() => {
    if (marcaSelecionadaId && formData.ano_modelo) {
      const fetchModelos = async () => {
        setLoadingModelos(true);
        try {
          const response = await fetch(`https://parallelum.com.br/fipe/api/v1/carros/marcas/${marcaSelecionadaId}/modelos`);
          if (response.ok) {
            const data = await response.json();
            const modelosData = data.modelos.map(m => ({ id: m.codigo, nome: m.nome }));
            setModelosFipe(modelosData);
          }
        } catch (error) {
          setModelosFipe([]);
        } finally {
          setLoadingModelos(false);
        }
      };

      fetchModelos();
    } else {
      setModelosFipe([]);
    }
  }, [marcaSelecionadaId, formData.ano_modelo]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    // Forçar maiúsculas na placa
    const finalValue = name === 'placa' ? value.toUpperCase() : value;
    
    setFormData(prev => ({ ...prev, [name]: finalValue }));
    
    // Limpar modelo e ano de fabricação quando ano modelo mudar
    if (name === 'ano_modelo') {
      setFormData(prev => ({ ...prev, modelo: '', ano_fabricacao: '' }));
      setModeloSelecionadoId(null);
    }
  };

  const handleMarcaSelect = (marcaNome) => {
    const marcaObj = marcasFipe.find(m => m.nome === marcaNome);
    if (marcaObj) {
      setMarcaSelecionadaId(marcaObj.id);
      setFormData(prev => ({ 
        ...prev, 
        marca: marcaNome, 
        modelo: ''
      }));
      setModeloSelecionadoId(null);
    }
  };

  const handleModeloSelect = (modeloNome) => {
    const modeloObj = modelosFipe.find(m => m.nome === modeloNome);
    if (modeloObj) {
      setModeloSelecionadoId(modeloObj.id);
      setFormData(prev => ({ ...prev, modelo: modeloNome }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.marca || !formData.modelo || !formData.ano_fabricacao || !formData.ano_modelo || !formData.placa) {
      if (onSave) onSave({ success: false, message: 'Preencha todos os campos obrigatórios: Marca, Modelo, Ano fabricação, Ano modelo e Placa.' });
      return;
    }
    if (formData.km && isNaN(Number(formData.km))) {
      if (onSave) onSave({ success: false, message: 'KM deve ser um número válido' });
      return;
    }

    try {
      const token = localStorage.getItem('token');
      const dataToSend = { ...formData };

      // Concatenar modelo + versão se houver versão
      if (dataToSend.versao) {
        dataToSend.modelo = `${dataToSend.modelo} ${dataToSend.versao}`.trim();
        dataToSend.modelo_base = formData.modelo; // Mantém o modelo base separado
      }

      const url = veiculo ? `${API_CONFIG.API_URL}/veiculos/${veiculo._id}` : `${API_CONFIG.API_URL}/veiculos`;
      const method = veiculo ? 'PUT' : 'POST';

      const response = await fetch(url, {
        method,
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(dataToSend)
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.message || `Erro HTTP ${response.status}`);
      }

      const result = await response.json();

      if (result.success === undefined || result.success) {
        if (onSave) onSave(result.data || result);
        onClose();
      } else {
        if (onSave) onSave({ success: false, message: result.message || 'Erro ao salvar veículo.' });
      }
    } catch (error) {
      if (onSave) onSave({ success: false, message: error.message || 'Erro ao conectar com o servidor' });
    }
  };

  const handleDelete = async () => {
    if (!window.confirm('Tem certeza que deseja excluir este veículo do estoque?')) {
      return;
    }

    try {
      if (onDelete) {
        await onDelete(veiculo._id);
        onClose();
      }
    } catch (error) {
    }
  };

  const podeEditar = true; // Permite edição para todos os usuários autenticados

  return (
    <div className="modal-overlay-preencher">
      <div className="modal-preencher-container" onClick={(e) => e.stopPropagation()}>
        <div className="modal-preencher-header">
          <div style={{ display: 'flex', alignItems: 'center', gap: '16px', flex: 1 }}>
            <h2>{veiculo ? 'Editar Veículo' : 'Cadastrar Veículo'}</h2>
            {veiculo && onVerJornada && (
              <button 
                type="button"
                onClick={() => onVerJornada(veiculo._id)}
                className="btn-secondary"
                style={{ 
                  padding: '8px 16px',
                  fontSize: '0.9rem',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '6px'
                }}
              >
                📋 Jornada
              </button>
            )}
            {veiculo && onToggleSeguir && (
              <button 
                type="button"
                onClick={() => {
                  onToggleSeguir(veiculo._id);
                  setSeguindoLocal(!seguindoLocal);
                }}
                className="btn-secondary"
                style={{ 
                  padding: '8px 16px',
                  fontSize: '0.9rem',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '6px',
                  background: seguindoLocal ? '#3498db' : undefined,
                  color: seguindoLocal ? 'white' : undefined
                }}
                title={seguindoLocal ? 'Deixar de acompanhar este veículo' : 'Acompanhar este veículo'}
              >
                🔔 {seguindoLocal ? 'Acompanhando' : 'Acompanhar'}
              </button>
            )}
          </div>
          <button className="modal-close-btn" onClick={onClose}>×</button>
        </div>

        {/* Steps Navigation */}
        <div className="section-steps">
          <div className={`step ${currentStep >= 1 ? 'active' : ''} ${currentStep > 1 ? 'completed' : ''}`} onClick={() => setCurrentStep(1)}>
            <div className="step-number">1</div>
            <span className="step-label">Identificação</span>
          </div>
          <div className={`step ${currentStep >= 2 ? 'active' : ''} ${currentStep > 2 ? 'completed' : ''}`} onClick={() => setCurrentStep(2)}>
            <div className="step-number">2</div>
            <span className="step-label">Detalhes</span>
          </div>
          <div className={`step ${currentStep >= 3 ? 'active' : ''} ${currentStep > 3 ? 'completed' : ''}`} onClick={() => setCurrentStep(3)}>
            <div className="step-number">3</div>
            <span className="step-label">Localização</span>
          </div>
        </div>

        <form onSubmit={handleSubmit} className="preencher-form-new">
          <div className="form-fields">
            {/* Passo 1: Identificação do Veículo */}
            {currentStep === 1 && (
              <div className="form-grid">
                <div className="form-group">
                  <label>Marca *</label>
                  {loadingMarcas ? (
                    <input type="text" value="Carregando marcas..." disabled />
                  ) : (
                    <AutocompleteInput
                      name="marca"
                      value={formData.marca}
                      onChange={handleInputChange}
                      onSelect={handleMarcaSelect}
                      options={marcasFipe.map(m => m.nome)}
                      placeholder="Digite para buscar marca..."
                      disabled={!podeEditar}
                      required
                    />
                  )}
                </div>

                <div className="form-group">
                  <label>Ano Modelo *</label>
                  <input 
                    type="number" 
                    name="ano_modelo" 
                    value={formData.ano_modelo} 
                    onChange={handleInputChange} 
                    disabled={!podeEditar || !formData.marca} 
                    placeholder={!formData.marca ? "Selecione marca primeiro" : "Ex: 2020"}
                    required 
                  />
                </div>

                <div className="form-group">
                  <label>Modelo *</label>
                  {loadingModelos ? (
                    <input type="text" value="Carregando modelos..." disabled />
                  ) : !marcaSelecionadaId || !formData.ano_modelo ? (
                    <input type="text" value="" placeholder="Selecione marca e ano modelo" disabled />
                  ) : (
                    <AutocompleteInput
                      name="modelo"
                      value={formData.modelo}
                      onChange={handleInputChange}
                      onSelect={handleModeloSelect}
                      options={modelosFipe.map(m => m.nome)}
                      placeholder="Digite para buscar modelo..."
                      disabled={!podeEditar}
                      required
                    />
                  )}
                </div>

                <div className="form-group">
                  <label>Versão</label>
                  <input
                    type="text"
                    name="versao"
                    value={formData.versao}
                    onChange={handleInputChange}
                    disabled={!podeEditar}
                    placeholder="Ex: LS VHC E 1.0"
                  />
                </div>

                <div className="form-group">
                  <label>Ano Fabricação *</label>
                  <select
                    name="ano_fabricacao" 
                    value={formData.ano_fabricacao} 
                    onChange={handleInputChange} 
                    disabled={!podeEditar || !formData.ano_modelo} 
                    required
                  >
                    <option value="">
                      {!formData.ano_modelo ? 'Selecione ano modelo primeiro' : 'Selecione...'}
                    </option>
                    {formData.ano_modelo && (
                      <>
                        <option value={parseInt(formData.ano_modelo) - 1}>
                          {parseInt(formData.ano_modelo) - 1}
                        </option>
                        <option value={formData.ano_modelo}>
                          {formData.ano_modelo}
                        </option>
                      </>
                    )}
                  </select>
                </div>

                <div className="form-group">
                  <label>Placa *</label>
                  <input 
                    type="text" 
                    name="placa" 
                    value={formData.placa} 
                    onChange={handleInputChange} 
                    disabled={!podeEditar} 
                    placeholder="ABC-1234"
                    required 
                  />
                </div>
              </div>
            )}

            {/* Passo 2: Detalhes */}
            {currentStep === 2 && (
              <div className="form-grid">
                <div className="form-group">
                  <label>Preço de Venda</label>
                  <input 
                    type="number" 
                    name="preco_venda" 
                    value={formData.preco_venda} 
                    onChange={handleInputChange} 
                    disabled={!podeEditar}
                    placeholder="Ex: 45000"
                  />
                </div>

                <div className="form-group">
                  <label>Cor</label>
                  <AutocompleteInput
                    name="cor"
                    value={formData.cor}
                    onChange={handleInputChange}
                    options={coresDisponiveis}
                    placeholder="Digite ou selecione uma cor..."
                    disabled={!podeEditar}
                  />
                </div>

                <div className="form-group">
                  <label>KM</label>
                  <input 
                    type="number" 
                    name="km" 
                    value={formData.km} 
                    onChange={handleInputChange} 
                    disabled={!podeEditar} 
                    placeholder="Ex: 50000"
                  />
                </div>

                <div className="form-group">
                  <label>Combustível</label>
                  <select 
                    name="combustivel" 
                    value={formData.combustivel} 
                    onChange={handleInputChange} 
                    disabled={!podeEditar}
                  >
                    <option value="">Selecione...</option>
                    <option value="Gasolina">Gasolina</option>
                    <option value="Etanol">Etanol</option>
                    <option value="Flex">Flex (Gasolina/Etanol)</option>
                    <option value="Diesel">Diesel</option>
                    <option value="GNV">GNV</option>
                    <option value="Híbrido">Híbrido</option>
                    <option value="Elétrico">Elétrico</option>
                  </select>
                </div>

                <div className="form-group full-width">
                  <label>Tipo</label>
                  <select 
                    name="tipo" 
                    value={formData.tipo} 
                    onChange={handleInputChange} 
                    disabled={!podeEditar}
                    title={tiposDescricao[formData.tipo]}
                  >
                    <option value="Venda normal">Venda normal</option>
                    <option value="Repasse 1">Repasse 1 - Sem garantia, margem baixa (R$ 500)</option>
                    <option value="Repasse 2">Repasse 2 - Motos (R$ 250)</option>
                    <option value="Repasse 3">Repasse 3 - Sem garantia, margem normal</option>
                  </select>
                  <small style={{ fontSize: '0.85em', color: '#666', display: 'block', marginTop: '4px' }}>
                    {tiposDescricao[formData.tipo]}
                  </small>
                </div>
              </div>
            )}

            {/* Passo 3: Localização e Status */}
            {currentStep === 3 && (
              <div className="form-grid">
                {/* Localização - apenas ao cadastrar, não ao editar */}
                {!veiculo && (
                  <div className="form-group full-width autocomplete-localizacao-container" style={{ position: 'relative' }}>
                    <label>Localização</label>
                    <input
                      type="text"
                      value={buscaLocalizacao}
                      onChange={handleBuscaLocalizacaoChange}
                      onFocus={() => setMostrarSugestoesLoc(true)}
                      placeholder="Digite para buscar localização ou fornecedor..."
                      disabled={!podeEditar}
                      autoComplete="off"
                    />
                    
                    {mostrarSugestoesLoc && podeEditar && (sugestoesLocalizacao.localizacoes.length > 0 || sugestoesLocalizacao.fornecedores.length > 0) && (
                      <div style={{
                        position: 'absolute',
                        top: '100%',
                        left: 0,
                        right: 0,
                        backgroundColor: 'white',
                        border: '1px solid #ddd',
                        borderRadius: '4px',
                        maxHeight: '300px',
                        overflowY: 'auto',
                        zIndex: 1000,
                        boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
                      }}>
                        {sugestoesLocalizacao.localizacoes.length > 0 && (
                          <>
                            <div style={{
                              padding: '8px 16px',
                              backgroundColor: '#f5f5f5',
                              fontWeight: 'bold',
                              fontSize: '0.85rem',
                              color: '#666'
                            }}>
                              Localizações Padrão
                            </div>
                            {sugestoesLocalizacao.localizacoes.map(loc => (
                              <div
                                key={loc}
                                onClick={() => selecionarLocalizacao(loc, null)}
                                style={{
                                  padding: '10px 16px',
                                  cursor: 'pointer',
                                  borderBottom: '1px solid #f0f0f0'
                                }}
                                onMouseEnter={(e) => e.target.style.backgroundColor = '#f9f9f9'}
                                onMouseLeave={(e) => e.target.style.backgroundColor = 'white'}
                              >
                                {loc}
                              </div>
                            ))}
                          </>
                        )}

                        {sugestoesLocalizacao.fornecedores.length > 0 && (
                          <>
                            <div style={{
                              padding: '8px 16px',
                              backgroundColor: '#f5f5f5',
                              fontWeight: 'bold',
                              fontSize: '0.85rem',
                              color: '#666',
                              borderTop: sugestoesLocalizacao.localizacoes.length > 0 ? '2px solid #ddd' : 'none'
                            }}>
                              Fornecedores
                            </div>
                            {sugestoesLocalizacao.fornecedores.map(fornecedor => (
                              <div
                                key={fornecedor._id}
                                onClick={() => selecionarLocalizacao(fornecedor.nome, fornecedor._id)}
                                style={{
                                  padding: '10px 16px',
                                  cursor: 'pointer',
                                  borderBottom: '1px solid #f0f0f0'
                                }}
                                onMouseEnter={(e) => e.target.style.backgroundColor = '#f9f9f9'}
                                onMouseLeave={(e) => e.target.style.backgroundColor = 'white'}
                              >
                                <div>{fornecedor.nome}</div>
                                {fornecedor.telefone && (
                                  <div style={{ fontSize: '0.85rem', color: '#999', marginTop: '2px' }}>
                                    {fornecedor.telefone}
                                  </div>
                                )}
                              </div>
                            ))}
                          </>
                        )}

                        {buscaLocalizacao.length > 0 && sugestoesLocalizacao.localizacoes.length === 0 && sugestoesLocalizacao.fornecedores.length === 0 && (
                          <div style={{ padding: '12px', color: '#999', textAlign: 'center' }}>
                            Nenhuma localização encontrada
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                )}

                <div className="form-group full-width">
                  <label>Status</label>
                  <select name="status" value={formData.status} onChange={handleInputChange} disabled={!podeEditar}>
                    <option>Disponível</option>
                    <option>Em negociação</option>
                    <option>Em preparação</option>
                  </select>
                </div>
              </div>
            )}
          </div>

          {/* Footer com navegação */}
          <div className="modal-preencher-footer">
            <div>
              {currentStep > 1 && (
                <button 
                  type="button" 
                  className="btn-secondary"
                  onClick={() => setCurrentStep(currentStep - 1)}
                >
                  ← Voltar
                </button>
              )}
            </div>
            <div>
              {currentStep < 3 ? (
                <button 
                  type="button" 
                  className="btn-primary"
                  onClick={() => setCurrentStep(currentStep + 1)}
                >
                  Próximo →
                </button>
              ) : (
                <>
                  {podeEditar && (
                    <>
                      <button type="button" className="btn-secondary" onClick={onClose}>Cancelar</button>
                      <button type="submit" className="btn-primary">Salvar</button>
                      {veiculo && onDelete && (
                        <button 
                          type="button" 
                          className="btn-danger" 
                          onClick={handleDelete}
                        >
                          🗑️ Excluir
                        </button>
                      )}
                    </>
                  )}
                  {!podeEditar && (
                    <button type="button" className="btn-secondary" onClick={onClose}>Fechar</button>
                  )}
                </>
              )}
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CadastrarVeiculoModalClean;
